
















































import Vue from "vue";
import Web3 from "web3";
import { AbiItem } from "web3-utils";
import UnicryptPresaleContractV4ABI from "../assets/UnicryptPresaleContractV4ABI.json";
import VueHcaptcha from "@hcaptcha/vue-hcaptcha";

export default Vue.extend({
  name: "UnicryptV4UserDeposit",

  components: { VueHcaptcha },

  data: () => ({
    web3: undefined as Web3 | undefined,
    connected: false as boolean,
    walletAddress: " " as string,
    balance: " " as string,
    targetContractAddress: "",
    sendBnb: "" as string,
    amount: 0 as number,
    gasLimit: "1000000" as string,
    gasPrice: "5" as string,
    transactionResults: [] as Array<string>,
    siteKey: "3a0c424a-39b2-4fa4-b19d-7f329d712b72",
    token: " " as string,
    antiBotKey: " " as string,
    antiBotWait: 3 as number,
    startBlock: " " as string,
    loading: false as boolean,
  }),
  methods: {
    async connect(): Promise<void> {
      const { ethereum } = window as any;
      if (!(ethereum /*&& ethereum.isMetaMask*/)) {
        alert("MetaMask がインストールされていません。");
      } else {
        const accounts = await ethereum.request({ method: "eth_requestAccounts" });
        this.web3 = new Web3(ethereum);
        const chainId = await this.web3.eth.getChainId();
        if (chainId != 56) {
          this.web3 = undefined;
          alert("BSC ネットワークで接続してください。");
        } else {
          ethereum.on("accountsChanged", () => {
            window.location.reload();
          });
          ethereum.on("chainChanged", () => {
            window.location.reload();
          });

          this.walletAddress = accounts[0];
          this.balance = Web3.utils.fromWei(await this.web3.eth.getBalance(this.walletAddress), "ether");
          this.connected = true;
        }
      }
    },
    async getPresaleInfo(): Promise<void> {
      if (this.web3 == null || !this.connected) {
        alert("MetaMask と接続してください。");
        return;
      }

      try {
        const unicryptPresaleContractV4Address = Web3.utils.toChecksumAddress(this.targetContractAddress);
        const unicryptPresaleContractV4ABI = UnicryptPresaleContractV4ABI as any as AbiItem;
        const unicryptPresaleContractV4 = new this.web3.eth.Contract(unicryptPresaleContractV4ABI, unicryptPresaleContractV4Address);

        const result = await unicryptPresaleContractV4.methods["getInfo()"]().call();
        this.startBlock = result["1"]["9"];
        this.startBlock = (Number(this.startBlock) + this.antiBotWait).toString();
      } catch (error) {
        this.transactionResults.push(error);
      }
    },
    async click(): Promise<void> {
      if (this.web3 == null || !this.connected) {
        alert("MetaMask と接続してください。");
        return;
      }

      try {
        this.transactionResults.splice(0);

        const unicryptPresaleContractV4Address = Web3.utils.toChecksumAddress(this.targetContractAddress);
        const unicryptPresaleContractV4ABI = UnicryptPresaleContractV4ABI as any as AbiItem;
        const unicryptPresaleContractV4 = new this.web3.eth.Contract(unicryptPresaleContractV4ABI, unicryptPresaleContractV4Address);

        const data = unicryptPresaleContractV4.methods.userDeposit(this.amount, this.antiBotKey).encodeABI();

        const nonce = await this.web3.eth.getTransactionCount(this.walletAddress);
        const transaction = {
          from: this.walletAddress,
          to: unicryptPresaleContractV4Address,
          data: data,
          value: Web3.utils.toWei(this.sendBnb, "ether"),
          gas: this.gasLimit,
          gasPrice: Web3.utils.toWei(this.gasPrice, "gwei"),
          nonce: nonce,
        };

        this.web3.eth
          .sendTransaction(transaction)
          .on("receipt", (receipt) => {
            const transactionStatus = receipt.status ? "Success" : "Failed";
            this.transactionResults.push(`transactionHash: ${receipt.transactionHash}, result: ${transactionStatus}`);
          })
          .on("error", (error) => {
            this.transactionResults.push(error.message);
          });
      } catch (error) {
        this.transactionResults.push(error);
      }
    },
    onVerify(token: any, eKey: any): void {
      this.token = token;
    },
    async getAntiBotKey(): Promise<void> {
      try {
        this.antiBotKey = " ";
        this.loading = true;

        const response = await fetch("https://api-pcakev2.unicrypt.network/api/v1/anti-bot/v4/get-participation-key", {
          method: "POST",
          mode: "cors",
          cache: "no-cache",
          referrerPolicy: "strict-origin-when-cross-origin",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            presale_contract: this.targetContractAddress,
            user: this.walletAddress,
            contract_version: 4,
            hcaptcha_token: this.token,
          }),
        });
        const result = await response.json();
        if (result["success"] == true) {
          this.antiBotKey = result["key"];
          this.click();
        } else {
          this.antiBotKey = "error";
          (this.$refs.captcha as VueHcaptcha).reset();
        }
      } catch (error: any) {
        this.transactionResults.push(error);
      } finally {
        this.loading = false;
      }
    },
  },
});
